<template>
  <div style="width: 100%; height: 100%">
    <div style="width: 100%; height: 100%"
      v-if="plugin">
      <div class="columns is-multiline" style="width: 100%; height: 100%">
        <!-- 플러그인 관리 -->
        <iframe :src="plugin.backoffice_view+`?host=${host}`" style="width: 100%; height: 100%"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
  import BreadCrumb from '../../module/common/BreadCrumb'
  import InputImg from '../../module/common/InputImg'
  import LpInputText from '../../module/common/LpInputText'
  import LpAddress from '../../module/common/LpAddress'
  import LpCheckBool from "../../module/common/LpCheckBool";
  import AdminFormItem from "../../module/admin/AdminFormItem";

  export default {
    layout: 'Main',
    components: {
      AdminFormItem,
      LpCheckBool,

      InputImg,
      LpInputText,
      LpAddress
    },

    data() {
      return {
        value: null,
        internalPlugins: null,
        plugin: null,
      };
    },

    created() {
        this.$axios.get(this.masterBackendUrl + 'public/plugin/' + this.$route.params.id).then(res => {
          if(res.status=== 200) {
            this.plugin=res.data;
          }
        });
    },

    methods: {
      save() {
      },
    },
    computed: {
      host() {
        return window.location.host;
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  //@import '~assets/css/lp_main'

  .btn-link
    border 1px solid #008fd9
    padding 4px 8px
    border-radius 3px
    font-size 0.7rem
    color: #008fd9
    display inline-block

  .btn-link:hover
    cursor pointer
    background-color #008fd9
    color #ffffff

  .desc
    font-size 0.8rem
    margin-top 4px
    color #787878

  #file
    position fixed
    bottom -100px
    left -100px

</style>
